// Configuration de l'application
// Supporte les variables d'environnement au build-time et au runtime

// Fonction pour r\u00e9cup\u00e9rer la variable d'environnement
const getEnvVar = (key, defaultValue = '') => {
  // 1. V\u00e9rifier si window._env_ existe (runtime via docker-entrypoint.sh)
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  
  // 2. Sinon, utiliser process.env (build-time)
  if (process.env[key]) {
    return process.env[key];
  }
  
  // 3. Valeur par d\u00e9faut
  return defaultValue;
};

/**
 * Base utilisée par axios : doit toujours pointer vers le préfixe FastAPI `/api`.
 * Si REACT_APP_BACKEND_URL est `http://host:8402` (sans `/api`), les appels partent vers
 * `/settings/...` au lieu de `/api/settings/...` → 404 « Not Found ».
 */
function normalizeBackendApiBase(raw) {
  const u = String(raw ?? '/api').trim();
  if (!u) return '/api';
  if (!/^https?:\/\//i.test(u)) {
    const t = u.replace(/\/+$/, '');
    if (t === '' || t === '/') return '/api';
    if (t === '/api' || t.endsWith('/api')) return t;
    return `${t}/api`;
  }
  try {
    const parsed = new URL(u);
    let path = parsed.pathname.replace(/\/+$/, '') || '';
    if (path === '' || path === '/') {
      parsed.pathname = '/api';
    } else if (!path.endsWith('/api')) {
      parsed.pathname = `${path}/api`;
    }
    return parsed.href.replace(/\/+$/, '');
  } catch {
    return '/api';
  }
}

// Configuration export\u00e9e
export const config = {
  // Chemin relatif `/api` (dev + proxy) ou URL absolue se terminant par `/api`
  BACKEND_URL: normalizeBackendApiBase(getEnvVar('REACT_APP_BACKEND_URL', '/api')),
};

export default config;
